
import type { Error as PlayError } from '@empathybroker/tsclient-play/dist/models/error'
import type { PlayResponse } from '@empathybroker/tsclient-play/dist/models/play-response'
import type { List } from '@empathybroker/tsclient-play/dist/models/search/list'
import type { Result } from '@empathybroker/tsclient-play/dist/models/search/result'
import { DomainEnum } from '@empathybroker/tsclient-play/dist/enums/domain.enum'
import { defineComponent } from 'vue'

import { mapActions } from 'vuex'

import ConfigurationsForm from '../../components/configurations/configurations-form.component.vue'
import ConfigurationsSearchInput from '../../components/configurations/configurations-search-input.component.vue'
import { EpbKeywords } from '../../components/shared/epb-keywords'

import { FeatureIdEnum } from '../../enums/feature-id.enum'

import { ConfigurationsFormMixin } from '../../mixins/configurations-form.mixin'

import { ROUTER_CONSTS } from '../../router/router.consts'
import { SEARCH_CONSTS } from '../../store/search/search.consts'

export default defineComponent({
  name: 'SearchConfigurationsForm',
  components: {
    EpbKeywords,
    ConfigurationsForm,
    ConfigurationsSearchInput,
  },
  mixins: [ConfigurationsFormMixin],
  data() {
    return {
      updateMode:
        this.$route.name ===
        ROUTER_CONSTS.routes[FeatureIdEnum.CONFIGURATION][DomainEnum.SEARCH].update,
      item: {
        enabled: true,
        name: undefined,
        context: {
          keywords: [],
          pivots: {},
        },
        ranking: {
          products: {
            elements: [],
          },
          attributes: {
            elements: [],
          },
        },
        restricted: {},
      },
      selectedKeyword: undefined,
      userQuery: undefined,
    }
  },
  computed: {
    loadSearchDataEnabled(): boolean {
      return (
        ConfigurationsFormMixin.computed.loadSearchDataEnabled.bind(this)() && !!this.searchQuery
      )
    },
    searchQuery(): string {
      let searchQuery: string
      if (this.selectedKeyword) {
        searchQuery = this.selectedKeyword
        if (this.userQuery) {
          searchQuery += ` ${this.userQuery}`
        }
      }
      return searchQuery
    },
    loadPreviewDisabled(): boolean {
      return !!this.userQuery
    },
  },
  methods: {
    ...mapActions(SEARCH_CONSTS.moduleName, {
      search: SEARCH_CONSTS.actions.search,
    }),
    async onItemLoad(): Promise<void> {
      this.watchers.searchQuery = this.$watch('searchQuery', this.onSearchQueryWatch)
      await ConfigurationsFormMixin.methods.onItemLoad.bind(this)()
    },
    fetchSearchData(): Promise<PlayResponse<List<Result>> | PlayError> {
      return this.search({
        query: this.searchQuery,
        filters: this.searchFilters,
        pagination: this.pagination,
        params: {
          ...this.resultsPreviewParams,
        },
      })
    },
    async onSearchQueryWatch(): Promise<void> {
      await this.loadSearchData({ resetPagination: true })
    },
  },
  watch: {
    'item.context.keywords': {
      handler(keywords: string[]): void {
        if (!this.selectedKeyword || !keywords.includes(this.selectedKeyword)) {
          this.selectedKeyword = this.item.context.keywords[0]
        }
      },
      immediate: true,
    },
  },
})
